define(function(require, exports, module) {
    'use strict';

    var i18n = require('i18n');
    var constants = require('common/addressLookup/sourceProvider/constants');

    module.exports = {
        // Edge workaround, because `fetch` returns promise without `finally`
        secureFetch: function(url, options) {
            return new window.Promise(function(resolve, reject) {
                window.fetch(url, options).then(resolve, reject);
            });
        },

        parseResponse: function(response) {
            return response.json()
                .then(data => {
                    var rawItems = data.Items;

                    if (rawItems.length === 1 && rawItems[0].Error) {
                        throw this.parseResponseError(rawItems[0]);
                    }

                    return rawItems;
                });
        },

        parseFind: function(response) {
            return this.parseResponse(response)
                .then(rawItems => {
                    return rawItems.map(item => ({
                        id: item.Id,
                        type: item.Type,
                        text: item.Text,
                        description: item.Description,
                        highlight: item.Highlight
                    }));
                })
                .catch(error => {
                    throw this.createParsingError(error);
                });
        },

        parseRetrieve: function(response) {
            return this.parseResponse(response)
                .then(rawItems => {
                    return rawItems.map(item => ({
                        id: item.Id,
                        label: item.Label,
                        state: item.Province,
                        province: item.Province,
                        city: item.City,
                        address: item.Line1,
                        address2: item.Line2,
                        zip: item.PostalCode,
                        streetName: item.Street,
                        buildingNumber: item.BuildingNumber,
                        propertyNumber: item.BuildingNumber,
                        subbuilding: item.SubBuilding,
                        unitNumber: item.SubBuilding,
                        isRetrievedAddress: true
                    }));
                })
                .catch(error => {
                    throw this.createParsingError(error);
                });
        },

        parseResponseError: function(error) {
            return {
                errorCode: error.Error,
                errorMessage: i18n.t('playtech.mobile.registration.addressLookup.serviceError.default')
            };
        },

        createFetchError: function(error) {
            if (error.errorCode !== undefined) {
                return error;
            }

            if (error.name === 'AbortError') {
                return { errorCode: constants.ABORT_ERROR };
            }

            return {
                ...error,
                errorCode: constants.NETWORK_ERROR,
                errorMessage: i18n.t('playtech.mobile.registration.addressLookup.serviceError.networkError')
            };
        },

        createParsingError: function(error) {
            if (error.errorCode !== undefined) {
                return error;
            }

            return {
                ...error,
                errorCode: constants.PARSE_ERROR,
                errorMessage: i18n.t('playtech.mobile.registration.addressLookup.serviceError.default')
            };
        },
    };
});
